import styled from "styled-components"

export const NoData = styled.div`
  text-align: center;
  padding: 24px;
  background-color: ${props => props.theme.colors.gameCardBgLight};
  color: ${props => props.theme.colors.white};
`
